'use client'

import { brandingConfig } from '@/config/branding'
import Image from 'next/image'

interface LogoProps {
	className?: string
	size?: 'sm' | 'md' | 'lg'
}

const textSizes = {
	sm: 'text-lg',
	md: 'text-2xl',
	lg: 'text-3xl',
}

/**
 * Logo
 * Renders the app logo dynamically from brandingConfig (platform.config.json).
 * Shows an image if logoUrl points to a real image, otherwise renders a text logo.
 */
export default function Logo({ className, size = 'md' }: LogoProps) {
	const { appName, logoUrl } = brandingConfig
	const isImageLogo =
		logoUrl && !logoUrl.endsWith('.svg') && !logoUrl.startsWith('/images/logo-sinko')

	if (isImageLogo) {
		return (
			<Image src={logoUrl} alt={appName} width={120} height={40} className={className} priority />
		)
	}

	return (
		<div className={`flex items-center gap-0.5 select-none ${className ?? ''}`}>
			<span className={`text-foreground font-extrabold tracking-tight ${textSizes[size]}`}>
				{appName}
			</span>
		</div>
	)
}
